import { RootState } from '../../store';

export const selectOrgRoles = (state: RootState) => state.accessControl.orgRoles;
export const selectOrgRolesLoading = (state: RootState) => state.accessControl.orgRolesLoading;

export const selectSubscribedModules = (state: RootState) => state.accessControl.subscribedModules;
export const selectSubscribedModulesLoading = (state: RootState) => state.accessControl.subscribedModulesLoading;

export const selectRoleMappings = (state: RootState) => state.accessControl.roleMappings;
export const selectRoleMappingsLoading = (state: RootState) => state.accessControl.roleMappingsLoading;

export const selectCreateOrgRoleSuccess = (state: RootState) => state.accessControl.createOrgRoleSuccess;
export const selectCreateOrgRoleLoading = (state: RootState) => state.accessControl.createOrgRoleLoading;
export const selectCreateOrgRoleError = (state: RootState) => state.accessControl.createOrgRoleError;

export const selectSaveMappingSuccess = (state: RootState) => state.accessControl.saveMappingSuccess;
export const selectSaveMappingLoading = (state: RootState) => state.accessControl.saveMappingLoading;
export const selectSaveMappingError = (state: RootState) => state.accessControl.saveMappingError;

export const selectAccessControlActionMessage = (state: RootState) => state.accessControl.actionMessage;

export const selectOrgStaff = (state: RootState) => state.accessControl.orgStaff;
export const selectOrgStaffLoading = (state: RootState) => state.accessControl.orgStaffLoading;
export const selectOrgStaffError = (state: RootState) => state.accessControl.orgStaffError;

export const selectCreateOrgStaffSuccess = (state: RootState) => state.accessControl.createOrgStaffSuccess;
export const selectCreateOrgStaffLoading = (state: RootState) => state.accessControl.createOrgStaffLoading;
export const selectCreateOrgStaffError = (state: RootState) => state.accessControl.createOrgStaffError;

export const selectDeleteOrgStaffSuccess = (state: RootState) => state.accessControl.deleteOrgStaffSuccess;
export const selectDeleteOrgStaffLoading = (state: RootState) => state.accessControl.deleteOrgStaffLoading;
export const selectDeleteOrgStaffError = (state: RootState) => state.accessControl.deleteOrgStaffError;

export const selectUpdateOrgStaffStatusSuccess = (state: RootState) => state.accessControl.updateOrgStaffStatusSuccess;
export const selectUpdateOrgStaffStatusLoading = (state: RootState) => state.accessControl.updateOrgStaffStatusLoading;
export const selectUpdateOrgStaffStatusError = (state: RootState) => state.accessControl.updateOrgStaffStatusError;

export const selectUpdateOrgStaffRoleSuccess = (state: RootState) => state.accessControl.updateOrgStaffRoleSuccess;
export const selectUpdateOrgStaffRoleLoading = (state: RootState) => state.accessControl.updateOrgStaffRoleLoading;
export const selectUpdateOrgStaffRoleError = (state: RootState) => state.accessControl.updateOrgStaffRoleError;

